// extracted by mini-css-extract-plugin
module.exports = {"bgVideo":"BackgroundVideo_bgVideo__kcJRV","fill":"BackgroundVideo_fill__w-fWd","poster":"BackgroundVideo_poster__VKiLi"};